<app-projects-overview-banner
  [filteredCount]="filteredCount()"
  [total]="total()"
  [organizationCount]="organizationCount()"
  [statusCounts]="statusCounts()"
  [loading]="loading()"
  (newProject)="onNewProject()"
/>

<div class="projects-body">
  <app-status-filter
    class="projects-filter"
    [selected]="statusFilter()"
    (selectedChange)="onFilterChange($event)"
  />
  @if (loadFailed()) {
    <div class="projects-error" role="alert">
      <p class="projects-error-message">Couldn't load your projects.</p>
      <button type="button" class="projects-error-retry" (click)="onRetryLoad()">Try again</button>
    </div>
  } @else {
    <app-feedback-round-listing
      [rounds]="rounds()"
      [loading]="listLoading()"
      (statusChange)="onStatusChange($event)"
      (openRound)="onOpenRound($event)"
    />
    <fb-pagination
      [page]="currentPage()"
      [total]="filteredCount()"
      [perPage]="pageSize()"
      label="projects"
      (pageChange)="page.set($event)"
    />
  }
</div>

@if (drawerOpen()) {
  <app-new-project-drawer
    [busy]="creatingProject()"
    (close)="drawerOpen.set(false)"
    (create)="onCreateProject($event)"
  />
}